export default __webpack_public_path__ + "static/media/blogapp.91863223.png";